module.exports = __webpack_public_path__ + "img/gps.39e91bd0.svg";